import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  createStaffUser,
  getStaffUser,
  listAccessPermissions,
  listStaffUsers,
  updateStaffUser,
  type CreateStaffUserBody,
  type UpdateStaffUserBody,
} from '@/api/map/staffUsers'

export function useAccessPermissions() {
  return useQuery({
    queryKey: ['cm', 'staff', 'permissions'],
    queryFn: listAccessPermissions,
  })
}

export function useStaffUsers(query: { page?: number; keyword?: string }) {
  return useQuery({
    queryKey: ['cm', 'staff', 'list', query],
    queryFn: () => listStaffUsers(query),
  })
}

export function useStaffUser(id: string | undefined) {
  return useQuery({
    queryKey: ['cm', 'staff', id],
    enabled: Boolean(id),
    queryFn: () => getStaffUser(id!),
  })
}

export function useCreateStaffUser() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: CreateStaffUserBody) => createStaffUser(body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['cm', 'staff'] })
    },
  })
}

export function useUpdateStaffUser(id: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: UpdateStaffUserBody) => updateStaffUser(id, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['cm', 'staff'] })
    },
  })
}
